import CustomButton from '../../../Components/CustomButton'
import './styles.scss'

const InfoCard = ({ onClick, text, btnLabel, subtitle }) => {
  return (
    <div className="home-page__info-card">
      <div className="home-page__info-card__headline">{text}</div>
      {subtitle && (
        <p className="home-page__info-card__subtitle">{subtitle}</p>
      )}
      <CustomButton label={btnLabel} onClick={onClick} />
    </div>
  )
}

export default InfoCard
